import React, { useState, useRef, useEffect } from 'react';
import './VideoScreen.css';
import CircleAnimation from './CircleAnimation';

const VideoScreen = () => {
  const [isVisible, setIsVisible] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2
      }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  return (
    <div className="video-screen-container" ref={videoRef}>
      <div className={`video-content ${isVisible ? 'visible' : ''}`}>
        <div className="video-icon-container">
          <img 
            src="/img/star.svg" 
            alt="Video Icon" 
            className="video-icon"
          />
        </div>
        <CircleAnimation />
        <h1 className="video-title">"With BonusClub <span className="ai-text">AI</span>, we've developed our own sales intelligence that helps B2B brands grow systematically – faster, more precisely, and more authentically than ever before."</h1>
        <p className="video-description">
        BonusClub is the platform for entrepreneurs, coaches, and creators who are ready to take responsibility, build structures, and transform their vision into measurable growth – without losing their authenticity.
        </p>
        
        <div className="video-frame-container">
          <div className="video-frame">
            <iframe
              className="video-iframe"
              src="https://www.youtube.com/embed/g4GuXZfzWho"
              title="Company Vision Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video-frame-button">
              <button 
                className="telegram-link"
                onClick={(e) => {
                  e.preventDefault();
                  const scaleUpCallSection = document.querySelector('.scaleup-call-wrapper');
                  if (scaleUpCallSection) {
                    scaleUpCallSection.scrollIntoView({ 
                      behavior: 'smooth',
                      block: 'start'
                    });
                  }
                }}
              >
              Book A Call with Julian
              </button>
            </div>
      </div>
    </div>
  );
};

export default VideoScreen; 